var utils = require('../../utils')

export default {
  name: 'send-pdf-history',
  utils: utils,

  data: function () {
    var today = new Date
    return {
      year: today.getFullYear(),
      month: today.getMonth() + 1,
      searchCallbackFlag: false,
      sendStatus: 0,
      shopName: this.$t('AllShopName'),
      order: -1,
      arrow: 'fa-arrow-down',
      page: 1,
      nextPage: false,
      renderHis: '',
      totalCount: 0
    }
  },
  created () {
    /** 検索条件の復元 */
    var ssYear = window.sessionStorage.getItem('phis-year')
    var ssMonth = window.sessionStorage.getItem('phis-month')
    var ssShopName = window.sessionStorage.getItem('phis-shopName')
    var ssSendStatus = window.sessionStorage.getItem('phis-selectStatus')
    var ssOrder = window.sessionStorage.getItem('phis-order')
    var ssArrow = window.sessionStorage.getItem('phis-arrow', this.arrow)

    if (!!ssYear) {
      this.year = ssYear
    }
    if (!!ssMonth) {
      this.month = ssMonth
    }
    if (!!ssShopName) {
      this.shopName = ssShopName
    }
    if (!!ssSendStatus) {
      this.sendStatus = ssSendStatus
    }
    if (!!ssOrder) {
      this.order = ssOrder
    }
    if (!!ssArrow) {
      this.arrow = ssArrow
    }
    this.search(false)
    /** 店舗 */
    this.getShops()
  },
  computed: {
    years () {
      var today = new Date
      var years = []
      for (var y = 2015; y <= today.getFullYear(); y++ ) {
        years.push({'id': y, 'text': y + this.$t('ymd.year')})
      }
      return years
    },
    months () {
      var months = []
      for (var m = 1; m <= 12; m++ ) {
        months.push({'id': m, 'text': m + this.$t('ymd.month')});
      }
      return months
    },
    /** 店舗 */
    shops () {
      return this.$store.getters.shops
    },
    pdfHistories () {
      return this.$store.getters.pdfSendHistories
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    authToken () {
      return window.localStorage.getItem('access_token')
    },
    orderHistories () {
      var reverse = this.order
      var his = this.$store.getters.pdfSendHistories.data
      var t = this.$t
      var status = this.sendStatus
      var shopName = this.shopName
      var sortHis = his.sort(function (a, b) {
        var adate = Date.parse(utils.wareki2Seireki(t, a['attributes'].cdate, 'y-m-d'))
        var atime = a['attributes'].ctime
        var bdate = Date.parse(utils.wareki2Seireki(t, b['attributes'].cdate, 'y-m-d'))
        var btime = b['attributes'].ctime

        if (adate < bdate) {
          return -1 * reverse
        } else if (adate == bdate) {
          if (atime < btime) {
            return -1 * reverse
          } else if (atime == btime) {
            return 0
          } else {
            return 1 * reverse
          }
        } else {
          return 1 * reverse
        }
      })
      var filterHis = []
      sortHis.forEach(function (value) {
        if (status == '0' || value.attributes['send-status'] + '' === status) {
          if (shopName === null || shopName === t('AllShopName') || shopName === value.attributes['shop-name']) {
            filterHis.push(value)
          }
        }
      })
      this.totalCount = filterHis.length
      if (this.page * 20 < this.totalCount) {
        this.nextPage = true
        this.renderHis = filterHis.slice(0, this.page * 20)
      } else {
        this.nextPage = false
        this.renderHis = filterHis
      }

      return this.renderHis
    }
  },
  methods: {
    search: function (readMore) {
      var url = null
      var clear = true
      var loadparams = 'true'
      var self = this

      if (readMore === 'sort') {
        // ソート読み込み
        clear = false
        loadparams = 'block'
      } else if (readMore === 'keepload') {
        // 再読み込み
        clear = false
        loadparams = 'block'
        this.searchCallbackFlag = true
      } else {
        // 通常
        this.searchCallbackFlag = false
      }

      var callback = function () {
        self.searchCallbackFlag = true
      }
      var data = {
        'year': this.year,
        'month': this.month
      }

      // Webストレージに検索条件を格納
      window.sessionStorage.setItem('phis-year', this.year)
      window.sessionStorage.setItem('phis-month', this.month)
      this.$store.dispatch('SEND_PDF_HISTORY_SEARCH', {url: url, data: data, loadparams: loadparams, callback: callback})
    },
    readPage: function () {
      this.page += 1
    },
    orderReverse: function () {
      this.order = this.order * -1
      window.sessionStorage.setItem('phis-order', this.order)
      this.arrow = this.order == 1 ? 'fa-arrow-up' : 'fa-arrow-down'
      window.sessionStorage.setItem('phis-arrow', this.arrow)
    },
    getArrow: function () {
      return this.arrow + ' color-light-blue'
    },
    setSelectStatus: function () {
      window.sessionStorage.setItem('phis-selectStatus', this.sendStatus)
      this.page = 1
    },
    setShopName: function () {
      window.sessionStorage.setItem('phis-shopName', this.shopName)
      // morepage初期化
      this.page = 1
    },
    /** 店舗 */
    getShops: function () {
      this.$store.dispatch('SHOP_ALL_SEARCH')
    },
    /** 戻る */
    goPrev: function () {
      this.$router.push({ path: '/', query: { type: this.$router.currentRoute.query.type }})
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/scripts/send-pdf-history.js